export const utilSetTimeout = (callback, delay) => {
    let startTime = performance.now();
    const handleCallback = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        if (elapsedTime >= delay) {
            callback();
        }
        else {
            requestAnimationFrame(handleCallback);
        }
    };
    requestAnimationFrame(handleCallback);
};
